import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import SpinAndWin from '../SpinAndWin'
import { displayProfileModal } from '../../../../modules/profile/actions/creators'
import { setFirstSpinModalOpen } from '../../../../modules/gamification/actions/creators'

const mapStateToProps = reduxState => {
  const { auth, profile, gamification } = reduxState
  const { accessToken } = auth
  const { advanceAccount } = profile

  return {
    accessToken,
    isUserAdvanced: advanceAccount && advanceAccount.advanced,
    firstSpinModalOpen: gamification.spin?.firstModalOpen,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      displayProfileModal,
      setFirstSpinModalOpen,
    },
    dispatch,
  )

const ConnectedComponent = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SpinAndWin)

export default ConnectedComponent
